import axios from 'axios'
import CFG from 'config'
import { trans } from '@dx/i18n'

/**
 * translation service: it uses the i18n module.
 *
 * if i18n is not configured in CFG (global or per-consumer), this service returns `options.default`.
 * If it's not given, either, the service returns `id`
 */
export default (id, options) => {
  if (!CFG.i18n) {
    return (options && options.default) || id
  }
  return trans(CFG.LANGUAGE, CFG.i18n.namespace, id, options)
}

// https://fe-apiproxy.musement.com/i18n?namespace=newagency-fe&lang=it
export const getI18n = lang => {
  const { host, endpoint, namespace } = CFG.i18n
  return axios.get(`${host}/${endpoint}?namespace=${namespace}&lang=${lang}`)
  .then(res => res.data)
}
